// Rules of the Crew Activity page (CrewActivity/schedule-list rows). Duty: activity type 0 / 1 = Fly, 2 = Non fly.

export const TIME_SLOTS = [
  { id: 0, name: "All time" },
  { id: 1, name: "00:00 - 06:00" },
  { id: 2, name: "06:00 - 12:00" },
  { id: 3, name: "12:00 - 18:00" },
  { id: 4, name: "18:00 - 23:59" },
];

/** Clickable tiles; one at a time ("" = all). Non fly is the default, as before. */
export const TILES = [
  { id: "fly", label: "Fly", icon: "fas fa-plane-departure" },
  { id: "nonFly", label: "Non fly", icon: "fas fa-building" },
  { id: "changeHotel", label: "Change hotel", icon: "fas fa-hotel" },
];
export const DEFAULT_TILE = "nonFly";

const isNonFly = (a) => a.activityTypeId === 2;
const isFly = (a) => a.activityTypeId === 0 || a.activityTypeId === 1;
const TILE_MATCH = { fly: isFly, nonFly: isNonFly, changeHotel: (a) => a.allowAllocateHotel === true };

export function countActivities(list) {
  const count = { total: list.length, fly: 0, nonFly: 0, changeHotel: 0 };
  list.forEach((a) => {
    Object.keys(TILE_MATCH).forEach((k) => {
      if (TILE_MATCH[k](a)) count[k] += 1;
    });
  });
  return count;
}

/** Pickup time inside the slot (minutes from midnight); rows without a pickup time always match. */
function slotMatch(a, timeSlotId) {
  if (!timeSlotId || !a.pickupTime) return true;
  const d = new Date(a.pickupTime);
  const mins = d.getHours() * 60 + d.getMinutes();
  return [mins < 360, mins >= 360 && mins < 720, mins >= 720 && mins < 1080, mins >= 1080][timeSlotId - 1];
}

/** Rows shown: the selected tile and the time slot. */
export const filterActivities = (list, { tile = "", timeSlotId = 0 }) => list.filter((a) => (!tile || TILE_MATCH[tile](a)) && slotMatch(a, timeSlotId));

/** Sorted by pickup time; rows without one last (as before). */
export const byPickupTime = (list) =>
  [...list].sort((a, b) => {
    if (!a.pickupTime) return 1;
    if (!b.pickupTime) return -1;
    return new Date(a.pickupTime) - new Date(b.pickupTime);
  });

/** Row / card tone: the hotel can be changed (green) > non fly (amber) > fly (warm white) — the colours of before. */
export const activityTone = (a) => (a.allowAllocateHotel ? "hotel" : isNonFly(a) ? "nonfly" : "fly");

/** The hotel row is a drop-off at the hotel (trip types 2, 10, 16). */
export const isHotelDropOff = (a) => [2, 10, 16].includes(a?.tripTypeId || 0);

/** Gender cell / filter text: "FEMALE" (the crew type is in the Staff rank column). */
export const genderText = (a) => (a.crewGender ?? "").trim().toUpperCase();

/** Text searched in the mobile cards. */
export const activitySearchText = (a) =>
  [
    a.employeeNumber,
    a.fullName,
    a.airlineCrewType,
    a.crewBaseStation,
    a.airportCode,
    a.activityDisplay,
    a.activityLocationCode,
    a.transportationCompany,
    a.pickupLocation,
    a.dropOffLocation,
    a.tripTypeName,
    a.transactionId,
  ]
    .filter(Boolean)
    .join(" ");
